import { render, staticRenderFns } from "./venuetwo.vue?vue&type=template&id=e6736254&scoped=true&"
import script from "./venuetwo.vue?vue&type=script&lang=js&"
export * from "./venuetwo.vue?vue&type=script&lang=js&"
import style0 from "./venuetwo.vue?vue&type=style&index=0&id=e6736254&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6736254",
  null
  
)

export default component.exports